const INSERT_BUTTON_BUTTON = "insert-button-button";
const BUTTON_LINK_SETTINGS_BUTTON = "button-link-settings-button";
const ROOT = "button-viewer";
const SETTINGS_MODAL = "button-settings-modal";
const SETTINGS_TABS = "settings-tabs";
const SETTINGS_GENERAL_TAB = "settings-general-tab";
const SETTINGS_DESIGN_TAB = "settings-design-tab";
const DESIGN_SETTINGS_BORDER_WIDTH_INPUT = "design-settings-border-width-input";
const DESIGN_SETTINGS_CORNER_RADIUS_INPUT = "design-settings-corner-radius-input";
const DESIGN_SETTINGS_BACKGROUND_COLOR_INPUT = "design-settings-background-color-input";
const DESIGN_SETTINGS_TEXT_COLOR_INPUT = "design-settings-text-color-input";
const DESIGN_SETTINGS_BORDER_COLOR_INPUT = "design-settings-border-color-input";
const GENERAL_SETTINGS_BUTTON_TEXT_INPUT = "general-settings-button-text-input";
export {
  BUTTON_LINK_SETTINGS_BUTTON,
  DESIGN_SETTINGS_BACKGROUND_COLOR_INPUT,
  DESIGN_SETTINGS_BORDER_COLOR_INPUT,
  DESIGN_SETTINGS_BORDER_WIDTH_INPUT,
  DESIGN_SETTINGS_CORNER_RADIUS_INPUT,
  DESIGN_SETTINGS_TEXT_COLOR_INPUT,
  GENERAL_SETTINGS_BUTTON_TEXT_INPUT,
  INSERT_BUTTON_BUTTON,
  ROOT,
  SETTINGS_DESIGN_TAB,
  SETTINGS_GENERAL_TAB,
  SETTINGS_MODAL,
  SETTINGS_TABS
};
//# sourceMappingURL=data-hooks.js.map
